import { getStringValue } from '~/modules/guarantees/utils.ts';
import {
  GuaranteesApplicationStatus,
  GuaranteesFileType,
  type TGuaranteesApplicationFile,
} from '~/store/guarantees/types.ts';
import { normalizeGuaranteesApplicationStatus } from '~/store/guarantees/utils.ts';
import { MANAGER_APPROVAL_LETTER_MANUAL_SIGN_FALLBACK_FILE_NAME } from './constants.ts';

export type TManagerManualSignDocumentRow = {
  id: string;
  applicationFileId?: string;
  fileId?: string;
  fileName?: string;
};

export const isManagerApprovalLetterManualSignStatus = (
  status?: GuaranteesApplicationStatus | string | null
): boolean => {
  const normalizedStatus = normalizeGuaranteesApplicationStatus(status);

  return (
    normalizedStatus === GuaranteesApplicationStatus.AWAITING_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN ||
    normalizedStatus === GuaranteesApplicationStatus.IN_PROGRESS_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN
  );
};

export const mapManualSignedApprovalLetterFile = (
  files: TGuaranteesApplicationFile[] = []
): TManagerManualSignDocumentRow | null => {
  const manualSignedFile = files.find(
    (file) => file.fileType === GuaranteesFileType.LETTER_OF_APPROVAL_MANUAL_SIGNED
  );

  if (!manualSignedFile) {
    return null;
  }

  const applicationFileId = getStringValue(manualSignedFile.id);
  const fileId = getStringValue(manualSignedFile.fileId);

  if (!applicationFileId && !fileId) {
    return null;
  }

  return {
    id: applicationFileId || fileId,
    applicationFileId,
    fileId,
    fileName:
      getStringValue(manualSignedFile.description) ||
      MANAGER_APPROVAL_LETTER_MANUAL_SIGN_FALLBACK_FILE_NAME,
  };
};
